import { GenaiRequest, GenaiResponseData } from "@cohesive/api-client";
import { useQuery } from "@tanstack/react-query";
import { orgAPI } from "./api";

/**
 * Calls the generic genai endpoint (fast model + JSON schema) to explain an
 * action in plain language. A `useQuery` rather than a mutation so a given
 * `cacheKey` (e.g. a tool-call id) is fetched once and reused when a dialog is
 * reopened — the explanation of a fixed input never changes, so it's cached
 * indefinitely and gated on `enabled` to avoid spending tokens until asked for.
 */
export function useExplainAction({
  cacheKey,
  inputText,
  schema,
  enabled,
}: {
  cacheKey: string;
  inputText: string;
  schema: NonNullable<GenaiRequest["output_schema"]>;
  enabled: boolean;
}) {
  return useQuery<GenaiResponseData>({
    queryKey: ["explainAction", cacheKey],
    queryFn: async () =>
      orgAPI.genai.generate({
        input_text: inputText,
        output_schema: schema,
        output_schema_strict: true,
      }),
    enabled,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  });
}
